module.exports = __webpack_public_path__ + "static/media/ben-oshea@1x.1870d2ab.png";